import { supabase } from '../lib/supabase';

/**
 * Submit form data via Edge Function (server-side DB insert + email)
 * @param {string} formType - 'contact' or 'demo'
 * @param {object} formData - Form field data
 * @returns {Promise<{success: boolean, message: string, submissionId?: string}>}
 */
export const submitForm = async (formType, formData) => {
  try {
    // Call Edge Function to handle DB insert + email sending (server-side)
    const { data: result, error: functionError } = await supabase?.functions?.invoke(
      'send-form-email',
      {
        body: {
          formType,
          formData: {
            ...formData,
            pageUrl: window.location?.href,
            userAgent: navigator.userAgent
          }
        }
      }
    );

    if (functionError) {
      console.error('Edge Function error:', functionError);
      throw new Error(functionError?.message || 'Failed to submit form');
    }

    if (!result?.success) {
      throw new Error(result?.error || 'Form submission failed');
    }

    return {
      success: true,
      message: 'Thanks — we\'ll get back to you soon.',
      submissionId: result?.submissionId
    };
  } catch (error) {
    console.error('Form submission error:', error);
    return {
      success: false,
      message: error?.message || 'Something went wrong. Please try again.'
    };
  }
};

/**
 * Validate email format
 * @param {string} email
 * @returns {boolean}
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex?.test(email);
};